import * as React from 'react'
import { Accordion, Button, Card } from 'react-bootstrap'


interface EquipmentProps {

}

const Equipment : React.FunctionComponent<EquipmentProps> = ({}) : JSX.Element => {

    const equipment = [
        {
            id: 1,
            fk_company: 1,
            item: 'Moving Pads'
        },
        {
            id: 2,
            fk_company: 1,
            item: 'Dolly'
        }
    ]

    const renderEquipment = () : JSX.Element => {
        return (
            <Accordion>
                {equipment.map((item : any, index : number) => {
                    return (
                        <Card>
                            <Card.Header style={{backgroundColor: 'white'}}>
                                <Accordion.Header as={Button} variant="link" eventKey={index.toString()}>
                                    {item.item}
                                </Accordion.Header>

                            </Card.Header>
                            <Accordion.Collapse eventKey={index.toString()}>
                                <Card.Body>
                                    <h5>{item.item}</h5>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    )
                })}
            </Accordion>
        )
    }

    return (
        <div>
            <h3>Equipment</h3>
            {renderEquipment()}
            <Button>Add Equipment</Button>
        </div>
    )
}

export default Equipment